import { Reveal } from "./Reveal";
import { PROMISE, IMAGES } from "./data";

export const WhyUs = () => (
  <section id="why" aria-labelledby="why-heading" data-testid="why-us-section" className="py-16 md:py-24 bg-brand-surface2">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="relative rounded-[2.5rem] overflow-hidden aspect-[4/3] shadow-[0_30px_70px_-30px_rgba(2,71,157,0.35)]">
              <img src={IMAGES.cleaner} alt="A friendly Aid in Clean team member smiling in a bright, tidy home" className="h-full w-full object-cover" />
            </div>
            <div className="absolute -bottom-5 -right-4 rounded-3xl bg-brand-green px-6 py-4 shadow-xl">
              <div className="text-2xl font-heading font-extrabold text-brand-ink leading-none">99.4%</div>
              <div className="text-sm font-bold text-brand-ink/80 mt-1">would recommend us</div>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">Our promise</span>
            <h2 id="why-heading" className="mt-3 font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue">Cleaning you can genuinely trust</h2>
            <p className="mt-4 text-lg text-brand-ink2 leading-relaxed max-w-xl">We started Aid in Clean to treat every home and workplace with the same warmth and care we'd give our own family.</p>
          </Reveal>
          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {PROMISE.map((p, i) => (
              <Reveal key={p.title} delay={0.06 * i}>
                <div className="flex gap-4">
                  <span className="shrink-0 grid place-items-center h-12 w-12 rounded-2xl bg-white text-brand-blue border border-brand-line"><p.icon className="h-6 w-6" strokeWidth={2} aria-hidden="true" /></span>
                  <div>
                    <h3 className="text-lg font-heading font-bold text-brand-ink">{p.title}</h3>
                    <p className="mt-1 text-base text-brand-ink2 leading-relaxed">{p.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
